import React from 'react';
import { Box, Typography } from '@mui/material';

import { AutoCompleteSelectUI, ButtonUI, FormLabelUI, InputUI } from '../../Interface';
import { generateAutocompleteItems } from '../../../utils/helper';

const TargetDocTab = ({
  targetWhsCode,
  targetBinId,
  note,
  warehouseData,
  warehouseOptions,
  onTargetWhsChange,
  onTargetBinChange,
  onNoteChange,
  onSave,
}) => {
  return (
    <Box sx={{ px: 1, pb: 1, pt: 3 }}>
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 1.5,
          bgcolor: 'grey.100',
        }}
      >
        <Box sx={{ mt: 1, display: 'grid', gridTemplateColumns: 'repeat(1, minmax(0, 1fr))', gap: 1.5 }}>
          <Box sx={{ bgcolor: 'common.white' }}>
            <AutoCompleteSelectUI
              label={<FormLabelUI text="Cél raktár" />}
              InputLabelProps={{ shrink: Boolean(targetWhsCode) }}
              selectedValue={targetWhsCode}
              selectedLabelValue={warehouseData.find((w) => w.code === targetWhsCode)?.name ?? ''}
              onChange={(_e, newVal) => {
                const nextWhsCode = newVal?.value ?? '';
                const whs = warehouseData.find((warehouse) => warehouse.code === nextWhsCode);
                onTargetWhsChange(nextWhsCode, whs);
              }}
              dataset={warehouseOptions}
              size="small"
              variant="outlined"
            />
          </Box>

          {(() => {
            const whs = warehouseData.find((warehouse) => warehouse.code === targetWhsCode);
            if (!whs?.binManaged) return null;

            const binOptions = generateAutocompleteItems(whs?.bin ?? [], 'binCode', 'binId');
            const selectedBin = (whs?.bin ?? []).find((bin) => bin.binId === targetBinId);

            return (
              <Box sx={{ bgcolor: 'common.white' }}>
                <AutoCompleteSelectUI
                  label={<FormLabelUI text="Cél rakhely" />}
                  InputLabelProps={{ shrink: Boolean(targetBinId) }}
                  selectedValue={targetBinId}
                  selectedLabelValue={selectedBin?.binCode ?? ''}
                  onChange={(_e, newVal) => {
                    onTargetBinChange(newVal?.value ?? null);
                  }}
                  dataset={binOptions}
                  size="small"
                  variant="outlined"
                />
              </Box>
            );
          })()}

          <InputUI
            fullWidth
            size="small"
            sx={{ '& .MuiInputBase-root': { bgcolor: 'common.white' } }}
            multiline
            minRows={3}
            label={<FormLabelUI text="Megjegyzés" />}
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <ButtonUI text="Rögzítés" className="bg-success" onClick={onSave} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TargetDocTab;
